const profile = {
    name: 'İsim',
    avatar: 'Avatar',
    givenName: 'Ad',
    familyName: 'Soyad',
    middleName: 'İkinci Ad',
    fullName: 'Tam Ad',
    nickname: 'Takma Ad',
    preferredUsername: 'Tercih Edilen Kullanıcı Adı',
    profile: 'Profil',
    website: 'Web Sitesi',
    gender: 'Cinsiyet',
    birthdate: 'Doğum Tarihi',
    zoneinfo: 'Zaman Dilimi',
    locale: 'Dil',
    address: {
        formatted: 'Adres',
        streetAddress: 'Sokak adresi',
        locality: 'Şehir',
        region: 'Eyalet/İl',
        postalCode: 'Posta kodu',
        country: 'Ülke',
    },
};
export default Object.freeze(profile);
